import 'angular-gettext';
import { get } from 'lodash/fp';
import accounts, { AccountsService } from '../../common/accounts/accounts.service';
import api, { ApiService } from '../../common/api/api.service';
import help, { HelpService } from '../../common/help/help.service';
import preferencesOrganization, {
    PreferencesOrganizationService,
} from '../../preferences/integrations/organization/organization.service';
import serverConstants, { ServerConstantsService } from '../../common/serverConstants/serverConstants.service';
import setup, { SetupService } from '../setup.service';
import users, { UsersService } from '../../common/users/users.service';

export class ConnectController {
    addOrganization: boolean;
    organization: any;
    password: string;
    saving: boolean;
    selected: any;
    selectedKey: string;
    username: string;
    showHelpButton = true;
    appName: string = process.env.APP_NAME;
    constructor(
        private $rootScope: ng.IRootScopeService,
        private $window: ng.IWindowService,
        private gettextCatalog: ng.gettext.gettextCatalog,
        private accounts: AccountsService,
        private api: ApiService,
        private help: HelpService,
        private preferencesOrganization: PreferencesOrganizationService,
        private serverConstants: ServerConstantsService,
        private users: UsersService,
        private setup: SetupService,
    ) {
        if (!this.help.variables().HS_SETUP_FIND_ORGANIZATION?.length) {
            this.showHelpButton = false;
        }
    }
    $onInit(): void {
        this.reset();
        this.users.listOrganizationAccounts().then(() => {
            this.addOrganization = this.users.organizationAccounts.length === 0;
        });
        this.$rootScope.$on('accountListUpdated', () => {
            this.users.listOrganizationAccounts(true);
        });
        // Remove Navigator Org in case user in public or secondary group
        if (this.users.current.preferences.public_group_member) {
            this.removeItemByKey(this.help.variables().NAV_ORG_ID);
        }
    }
    add(): ng.IPromise<void> {
        this.saving = true;
        return this.preferencesOrganization
            .createAccount(this.username, this.password, this.selectedKey)
            .then(() => {
                return this.users.listOrganizationAccounts(true).then(() => {
                    this.saving = false;
                    this.addOrganization = false;
                    this.username = '';
                    this.password = '';
                });
            })
            .catch((err) => {
                this.saving = false;
                throw err;
            });
    }
    disconnect(id): ng.IPromise<void> {
        this.saving = true;
        const successMessage = this.gettextCatalog.getString('{{app_name}} removed your organization integration', {
            app_name: process.env.APP_NAME,
        });
        const errorMessage = this.gettextCatalog.getString(
            "{{app_name}} couldn't save your configuration changes for that organization",
            {
                app_name: process.env.APP_NAME,
            },
        );
        return this.preferencesOrganization
            .disconnect(id, successMessage, errorMessage)
            .then(() => {
                this.saving = false;
                return this.users.listOrganizationAccounts(true).then(() => {
                    this.addOrganization = this.users.organizationAccounts.length === 0;
                });
            })
            .catch((err) => {
                this.saving = false;
                throw err;
            });
    }
    reset(): void {
        this.addOrganization = false;
        this.saving = false;
        this.organization = null;
        this.username = '';
        this.password = '';
    }
    select(): void {
        this.username = '';
        this.password = '';
        this.selected = get(this.selectedKey, this.serverConstants.data.organizations_attributes);
    }
    next(): ng.IPromise<void> {
        this.saving = true;
        return this.setup.next().then(() => {
            this.saving = false;
        });
    }
    showOrganizationHelp(): void {
        this.help.article(this.gettextCatalog.getString(this.help.variables().HS_SETUP_FIND_ORGANIZATION));
    }
    authenticate(organizationId): void {
        this.saving = true;
        this.$window.location.href = this.preferencesOrganization.oAuth(organizationId, 'setup/connect');
    }
    removeItemByKey(key: string): void {
        if (this.serverConstants && this.serverConstants.data && this.serverConstants.data.organizations_attributes) {
            // Remove the item with the specified key
            delete this.serverConstants.data.organizations_attributes[key];
        }
    }
}

const Connect = {
    template: require('./connect.html'),
    controller: ConnectController,
};

export default angular
    .module('mpdx.setup.connect.component', [
        'gettext',
        accounts,
        api,
        help,
        preferencesOrganization,
        serverConstants,
        setup,
        users,
    ])
    .component('setupConnect', Connect).name;
